import React from "react";
import { InputRangeRow } from "./index";
// Used by Heli KV2008B and Heli KV2019B machines

export default function PackageTypeRow() {
   return (
      <InputRangeRow
         titleProp={"Package Type"}
         descriptionProp={""}
         sizeProp={6}
         colSizeProp={6}
         typeProp={"text"}
         minProp={1}
         maxProp={4}
         propertyNameProp={"packageType"}
         errorDialogueProp={"1-4"}
         floatProp={false}
      />
   );
}
